import { useCallback } from 'react';
import { IStationModalData } from 'common/context/stationInfo/types/stationModalData';
import { useStationInfoContext } from 'common/context/stationInfo';
import { useApplicationOperations, MODALS } from 'entities/application';

const useHandlerShowStationModal = () => {
  const { addActiveModal } = useApplicationOperations();
  const { setStationModalData } = useStationInfoContext();

  const handlerShowStationModal = useCallback(
    (data: IStationModalData) => {
      setStationModalData(data);
      addActiveModal(MODALS.station);
    },
    [setStationModalData, addActiveModal]
  );

  return handlerShowStationModal;
};

export default useHandlerShowStationModal;
